export default __webpack_public_path__ + "static/media/warning--roadworks--g5.e61ab484.png";